var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0125 11.2583L5.30833 52.5C4.79899 53.3821 4.52949 54.3821 4.52663 55.4007C4.52378 56.4192 4.78768 57.4208 5.29208 58.3057C5.79647 59.1906 6.52378 59.928 7.40165 60.4446C8.27951 60.9611 9.27733 61.2388 10.2958 61.25H59.7042C60.7227 61.2388 61.7205 60.9611 62.5984 60.4446C63.4762 59.928 64.2035 59.1906 64.7079 58.3057C65.2123 57.4208 65.4762 56.4192 65.4734 55.4007C65.4705 54.3821 65.201 53.3821 64.6917 52.5L39.9875 11.2583C39.4675 10.4011 38.7354 9.69242 37.8618 9.20056C36.9882 8.70871 36.0026 8.45032 35 8.45032C33.9974 8.45032 33.0118 8.70871 32.1382 9.20056C31.2646 9.69242 30.5325 10.4011 30.0125 11.2583Z",
    stroke: "#EF5C69",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 26.25V43.9167",
    stroke: "#EF5C69",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49.5834H35.0292",
    stroke: "#EF5C69",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.43c36ae1a05a87cb81e85c6bda4976ef.svg";
export { ForwardRef as ReactComponent };